function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 2.684
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.946 9.82s.923-4.964.923-5.656c0-.692.692-.808 1.384.116.693.923 3.809 5.423 3.809 5.423l-6.118.108z",
  fill: "#20201e",
  stroke: "#20201e",
  strokeWidth: 0.7101327199999999
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.341 47.885a58.184 58.184 0 00-1.262-6.398l-1.672-.669 1.117-1.335a55.668 55.668 0 00-2.188-6.064l-1.582-.448.79-1.348a55.252 55.252 0 00-2.711-5.06l-1.475-.295.53-1.218a56.612 56.612 0 00-3.239-4.497l-1.56-.17.416-1.217a55.405 55.405 0 00-3.643-3.888l-1.563-.088.273-1.119c-2.785-2.521-4.755-3.747-4.755-3.747L31.28 11.4s-1.693-.924-3.077-1.847c0 0-.924-3.077-1.23-4.77-.309-1.691-1.232-.922-1.539-.462-.309.462-3.5 4.001-3.5 4.001s-1.91-.262-3.27 0c-2 .385-2.924 1.732-5.231 3.924-1.685 1.599-2.694 3-3.27 4.5-.577 1.5.115 1.5-.115 2.885-.232 1.385-6.464 11.77-7.155 13.04-.693 1.27-2.365 5.151.923 7.617.922.692 1.615 1.04 2.192 1.269 0 0 .923-.23 1.27-.691.06-.083.093-.135.108-.162.01-.032.017-.033 0 0-.035.09-.117.427.238.852.577.693 1.318.643 1.731.693.615.078 1.73-.46 2.654-1.846.923-1.384 1.5-1.847 2.193-2.654.691-.808 4.511-2.595 6.001-5.078.346-.576 1.154-.346 1.73.116.577.462 3.808.578 5.193-1.731 0 0 .654 6.07-2.078 10.27-4.5 6.923-12.116 8.655-14.425 15.117h47.314c0-2.233-.118-4.378-.33-6.44l-1.574-.83 1.332-1.29z",
  fill: "#20201e",
  stroke: "#20201e",
  strokeWidth: 0.7101327199999999
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.968 12.949s20.155 15.079 20.155 42.313",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 0.7101327199999999
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.38 40.535c.017-.025.009-.025 0 0z",
  fill: "none",
  stroke: "#20201e",
  strokeWidth: 0.7101327199999999
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.815 23.412c.383 4.307-1.616 7.385-1.693 7.654 0 0 4.847-2.5 5.31-5.809M27.116 31.062s3.232 1.578 5.617.578",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 0.7101327199999999
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.272 40.701s2.154-2.77 2.77-4.039",
  fill: "none",
  stroke: "#20201e",
  strokeWidth: 0.7101327199999999
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.54 15.138s-3.548.017-4.731 1.96c-1.616 2.656.231 3.002.231 3.002s1.846.577 3.115-1.154c1.352-1.843.23-3 .23-3l1.149-.808zM3.351 34.7c1.27-.346 2.076-.231 2.653.116 0 0-.577-1.732.462-3.232 1.04-1.5 2.77-1.615 4.269-4.5M37.039 16.753l2.197-1.382M41.542 21.714l2.198-1.032M45.58 27.474l2.538-1.04M48.817 34.067l2.647-.924M51.348 41.8l2.771-.807M52.855 49.641l2.88-.34",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 0.7101327199999999
}));

function SvgBlackKnightR(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _ref);
}

export default SvgBlackKnightR;